document.addEventListener('DOMContentLoaded', function() {
  var contentElement = document.querySelector('.b2b-lock-prompt__content');
  if (contentElement) {
    var newDiv = document.createElement('div');
    var paragraph = document.createElement('p');
    paragraph.textContent = '¿Aún no tienes una cuenta? Rellena nuestra solicitud para poder darte acceso.';
    paragraph.className = 'account-prompt-text';
    newDiv.appendChild(paragraph);

    var link = document.createElement('a');
    link.className = 'button apply-button';
    link.href = 'https://shopify.com/67303932066/account/pages/511f338e-2c91-40b7-b3be-b14deee6a6d3';
    link.textContent = 'Solicitar cuenta';
    newDiv.appendChild(link);

    contentElement.appendChild(newDiv);

    const loginButton = contentElement.querySelector('a.button:not(.apply-button)');
    if (loginButton) {
      loginButton.classList.add('login-button');
    }
  }
});